/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react'
import Debounce from '../../../../CommonComponent/debounce';
import Modal from '../../../../CommonComponent/Modal';


export default function BidsHeader({bidsInfo,loading, searchValue, setSearchValue,setShowExportToastMsg,
    handleSearch, searchParam, setSearchParam, bids}) {
    const [showExportModel, setShowExportModel] =useState('');
    const [exportBtnLoading, setExportBtnLoading]=useState(false)

    let plan_type=localStorage.getItem('plan_type');

    useEffect(()=>{
        setSearchValue(searchParam.get('search_term') ? searchParam.get('search_term') : '')
    },[])

    const handleChange = (e,value)=>{
        handleSearch(e,'search_term',value.trim())
    }

    const changeHandler=(e)=>{
        let value=e.target.value;
        setSearchValue(value)
    }

    const optimizedFn = useCallback(
        Debounce((e,value) => handleChange(e,value)),
        [searchParam]
    );

    const exportModelHandler = ()=>{
        setShowExportModel(true)
    }

    const exportHandler=()=>{
        setExportBtnLoading(true)
        let params = Object.fromEntries(searchParam);
        params['bidsExport'] = true
        setSearchParam({...params})
        
        setTimeout(()=>{
            setExportBtnLoading(false)
            setShowExportModel(false)
            setShowExportToastMsg('Export complete')
        }, 1000)
        setTimeout(()=>{
            setShowExportToastMsg('')
        },3000)
    }
    return (
        <div className="mt-6 flex justify-between flex-wrap items-center">
            <p data-testid='lot-count' className="text-[16px] leading-normal font-medium text-[#343434]"> 
                <span>{bidsInfo?.total_records_found ? bidsInfo.total_records_found : 0} </span> 
                {bidsInfo?.total_records_found===1 ? 'Bid' : 'Bids'}
            </p>
            <div className="flex ml-auto  flex-wrap items-center">
                {/* <!-- search  --> */}
                <div className="relative pr-3 py-[12px]">
                    <input type="text" id="search-bid"
                        className="text-[14px] relative w-[270px] h-[32px] pl-8 pr-3 border 
                                border-[#A1A1A9] placeholder:text-[#A1A1A9] focus:border-[#343434] outline-none 
                                font-medium leading-normal text-[#4A4A4A]" placeholder="Search"
                        value={searchValue} maxLength={150}
                        onChange={(e)=>{e.preventDefault(); optimizedFn(e,e.target.value); changeHandler(e)}}
                    />
                    <img src="/images/search-icon-large.svg" alt="search-icon" 
                        className="absolute top-5 cursor-pointer 
                                left-2.5" />
                </div>
                {/* <!-- export button -->/ */}
                <div className="relative mr-2.5 cursor-pointer">
                    <button 
                        disabled={ bids.length === 0} 
                        type="button" id="export" onClick={exportModelHandler} 
                        className="text-[14px] sm:flex hidden sm:gap-2 text-[#52525A] border w-[89px] items-center 
                            disabled:text-[hsl(240,4%,65%)] disabled:border-[#D4D4D8] hover:bg-[#EFF1F8]
                            h-[32px] border-[#A1A1A9] rounded-[6px] leading-normal  font-medium justify-center">
                        <img src="/images/export-icon.svg" alt="export-icon" 
                            className={`${(bids.length === 0) && 'opacity-50'}`}
                        />
                        Export
                    </button>
                    <button type="button"  disabled={ bids.length === 0}
                        className="text-[14px] sm:hidden block text-[#52525A] border w-[35px] disabled:text-[hsl(240,4%,65%)]
                        h-[32px] border-[#A1A1A9] rounded-[6px] leading-normal  font-medium disabled:border-[#D4D4D8]">
                        <img src="/images/export-icon.svg" alt="export-icon" 
                            className={`ml-2 ${( bids.length === 0) && 'opacity-50'} `} 
                        />
                    </button>
                </div>
            </div>

            <Modal setIsOpen={setShowExportModel} isOpen={showExportModel} handleAction={exportHandler}
                loading={exportBtnLoading} buttonText="Export" id="export-btn"
                title="Auction Bids Data" close={true}
                description="By clicking ‘Export’, you acknowledge your responsibility for the safe handling of this data and agree to comply with all relevant laws and regulations as well as the Indy.auction terms of use and privacy policy."  />
        </div>   
    )
}